import React, { useState } from 'react';
import './login.css';

function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://penguintools.co.uk/RVTLogin.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `username=${username}&password=${password}`,
      });

      const data = await response.json();



      if (data.success) {
        console.log('Login successful:', data);
        handleLoginSuccess(data.user_id_from_table);
      } else {
        // Login failed
        setErrorMessage(data.message);
      }
    } catch (error) {
      console.error('Error:', error);
      setErrorMessage('An error occurred during login.');
    }
  };

  const handleLoginSuccess = (user_id_from_table) => {
    onLoginSuccess(user_id_from_table);
  };

  return (
    <div className="login">
      {errorMessage && <p className="error">{errorMessage}</p>}
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="username">Username:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Login</button>
        </form>
      <div className="links">
        <a href="https://www.penguintools.co.uk/my-account/">Register</a>
        <span> | </span>
        <a href="https://www.penguintools.co.uk/my-account/lost-password/">Forgot Password</a>
      </div>
    </div>
  );
}

export default Login;